<template>
  <div id="PlayVideo">
    <Drawer
        :title="editTitle"
        v-model="showDrawer"
        width="80%"
        @on-close="onClosePlay"
        :mask-closable="false"
    >
      <iframe style="width:100%;height:100%" ref="video" frameborder=0 allowfullscreen></iframe>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "PlayVideo",
  data() {
    return {
      editTitle: '',
      showDrawer: false,
      videoInfo: {
        url: ''
      }
    }
  },
  methods: {
    playVideo(video) {
      this.videoInfo = video
      this.$refs.video.src = this.videoInfo.url
      this.showDrawer = true
    },
    onClosePlay() {
      this.$refs.video.src = ""
    }
  }
}
</script>

<style scoped>

</style>
